import { useCallback } from 'react';

import { FormikConfig, FormikValues, useFormik } from 'formik';

export const useFormikCustom = <Values extends FormikValues = FormikValues>(
	formikConfig: FormikConfig<Values>
) => {
	const formik = useFormik(formikConfig);

	const onSubmit = useCallback(async (e: any) => {
		e.preventDefault()
		const errors = await formik.validateForm(formik.values);
		formik.handleSubmit();
		if (errors) {
			// do something
		}
	}, [formik]);

	return {
		...formik,
		onSubmit,
	};
};
